import { UploadSessionStatus } from '../../features/documentUpload/docUpload/docUploadTypes';

export enum UploadError {
    OverMaximumFileSize = 'maximumFileSize',
    OverMaximumNumberOfDocs = 'maximumNumberOfDocs',
    InvalidFileName = 'invalidFileName',
    InvalidFileType = 'invalidFileType',
    MinimumNumberOfDocs = 'minimumNumberOfDocs',
    NoProvidedFile = 'documentTypeSelected',
    FinishUploading = 'documentNotUploaded',
    UploadFailed = 'uploadFailed',
    MaximumTotalFilesSize= 'maximumTotalFilesSize',
}

export interface callbackErrorProps {
    status: UploadSessionStatus,
    errorMsg: UploadError
}
